











 

















const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MSTeamsProviderRowTeamMemberIntegrations",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MSTeamsIntegration",
      "kind": "LinkedField",
      "name": "msTeams",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TeamMemberIntegrationAuthWebhook",
          "kind": "LinkedField",
          "name": "auth",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationProviderWebhook",
              "kind": "LinkedField",
              "name": "provider",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TeamNotificationSettings",
          "kind": "LinkedField",
          "name": "teamNotificationSettings",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "NotificationSettings_settings"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TeamMemberIntegrations",
  "abstractKey": null
};

(node ).hash = "73e8925df2a024de2711245bafdb1e39";

export default node;
